(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fet-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.fxsReady) return;
      root.dataset.fxsReady = '1';

      var track = root.querySelector('[data-fxs-track]');
      var nav = root.querySelector('[data-fxs-nav]');
      var prev = root.querySelector('[data-fxs-prev]');
      var next = root.querySelector('[data-fxs-next]');
      var toast = root.querySelector('[data-fxs-toast]');
      var toastTimer = null;

      function say(msg) {
        if (!toast) return;
        toast.textContent = msg;
        toast.hidden = false;
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () {
          toast.hidden = true;
        }, 2600);
      }

      function syncNav() {
        if (!nav || !track) return;
        var overflows = track.scrollWidth > track.clientWidth + 4;
        var coarse = window.matchMedia('(hover: none)').matches;
        nav.hidden = !overflows || coarse;
        if (nav.hidden) return;
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      function page(dir) {
        if (!track) return;
        var card = track.querySelector('[data-fxs-card]');
        var step = card ? card.offsetWidth + 12 : 200;
        track.scrollBy({ left: dir * step * 3, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      if (track) track.addEventListener('scroll', syncNav, { passive: true });
      window.addEventListener('resize', syncNav);
      syncNav();

      root.querySelectorAll('[data-fxs-card]').forEach(function (card) {
        var sel = card.querySelector('[data-fxs-select]');
        var priceEl = card.querySelector('[data-fxs-price]');
        var addBtn = card.querySelector('[data-fxs-add]');

        if (sel) {
          sel.addEventListener('change', function () {
            var opt = sel.options[sel.selectedIndex];
            if (!opt) return;
            card.dataset.variantId = opt.value;
            if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
          });
        }

        if (!addBtn) return;
        addBtn.addEventListener('click', function () {
          var id = parseInt(card.dataset.variantId, 10);
          if (!id) return;
          var original = addBtn.textContent;
          addBtn.setAttribute('disabled', '');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          })
            .then(function (r) {
              if (!r.ok) {
                return r.json().then(function (err) {
                  throw new Error(err.description || 'Cart error');
                });
              }
              return r.json();
            })
            .then(function () {
              addBtn.classList.add('is-added');
              addBtn.textContent = 'Added';

              /* Same events + drawer selectors the buy box uses, so the cart drawer
                 opens identically from either entry point. */
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              var drawer = document.querySelector(
                'cart-drawer, [data-cart-drawer], .cart-drawer, #CartDrawer, .yv-cart-drawer'
              );
              if (drawer) {
                drawer.classList.add('is-open', 'open', 'active');
                drawer.removeAttribute('hidden');
                document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
              }

              setTimeout(function () {
                addBtn.classList.remove('is-added');
                addBtn.textContent = original;
                addBtn.removeAttribute('disabled');
              }, 1600);
            })
            .catch(function (e) {
              addBtn.removeAttribute('disabled');
              addBtn.textContent = original;
              say(e.message || 'Could not add to cart');
            });
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-fxs]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fet-duck-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBox(box) {
    if (box.dataset.duckInit) return;
    box.dataset.duckInit = '1';
    var form = box.querySelector('[data-duck-form]');
    var idInput = box.querySelector('[data-duck-id]');
    var planInput = box.querySelector('[data-duck-plan]');
    var cards = Array.prototype.slice.call(box.querySelectorAll('.vcard'));
    var modeBtns = box.querySelectorAll('.toggle button');
    var cadWrap = box.querySelector('[data-cad]');
    var cadBtns = box.querySelectorAll('[data-cad] button');
    var saveHint = box.querySelector('[data-savehint]');
    var atcPrice = box.querySelector('[data-atc-price]');
    var atcSub = box.querySelector('[data-atc-sub]');
    var shiptxt = box.querySelector('[data-shiptxt]');
    var shipgo = box.querySelector('[data-shipgo]');
    var shipbar = box.querySelector('[data-shipbar]');
    var qtyInput = box.querySelector('[data-duck-qty]');
    var qvalEl = box.querySelector('[data-qval]');
    var qplus = box.querySelector('[data-qplus]');
    var qminus = box.querySelector('[data-qminus]');
    var qtyRow = box.querySelector('[data-qtyrow]');
    var bmsmSpans = Array.prototype.slice.call(box.querySelectorAll('.bmsm span'));
    var qmax = qtyRow ? parseInt(qtyRow.dataset.qmax || '12', 10) : 12;
    var qty = 1;
    var threshold = parseInt(box.dataset.threshold || '4400', 10);
    var subpct = parseInt(box.dataset.subpct || '20', 10);
    var mode = (box.querySelector('.toggle button.on') ? 'sub' : 'otp');
    var planId = '';
    var activeCad = box.querySelector('[data-cad] button.on');
    if (activeCad) planId = activeCad.getAttribute('data-plan');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function selectedCard() {
      return box.querySelector('.vcard.on') || cards[0];
    }
    function render() {
      var card = selectedCard();
      if (!card) return;
      var base = parseInt(card.dataset.price, 10);
      var price = (mode === 'sub') ? Math.round(base * (100 - subpct) / 100) : base;
      // per-card price display
      cards.forEach(function (c) {
        var b = parseInt(c.dataset.price, 10);
        var now = c.querySelector('[data-now]');
        var was = c.querySelector('[data-was]');
        if (mode === 'sub') {
          if (now) now.textContent = money(Math.round(b * (100 - subpct) / 100));
          if (was) { was.textContent = money(b); was.style.display = ''; }
        } else {
          if (now) now.textContent = money(b);
          if (was) was.style.display = 'none';
        }
      });
      if (idInput) idInput.value = card.dataset.variant;
      if (planInput) planInput.value = (mode === 'sub') ? planId : '';
      var total = price * qty;
      if (atcPrice) atcPrice.textContent = money(total);
      if (atcSub) atcSub.textContent = (mode === 'sub') ? (atcSub.dataset.sub || '') : (atcSub.dataset.otp || '');
      if (qvalEl) qvalEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      // highlight the BMSM tier the current pack count unlocks (2 / 3 / 4+)
      if (bmsmSpans.length) {
        var tier = (qty >= 4) ? 2 : (qty === 3) ? 1 : (qty === 2) ? 0 : -1;
        bmsmSpans.forEach(function (s, i) { s.classList.toggle('on', i === tier); });
      }
      // free-ship bar (based on the displayed order total)
      if (shipbar) {
        var rem = threshold - total;
        if (rem > 0) {
          if (shiptxt) { shiptxt.style.display = 'inline'; shiptxt.textContent = 'Add ' + money(rem) + ' for FREE shipping'; }
          if (shipgo) shipgo.style.display = 'none';
          shipbar.style.width = Math.min(100, (total / threshold) * 100) + '%';
        } else {
          if (shiptxt) shiptxt.style.display = 'none';
          if (shipgo) shipgo.style.display = 'inline';
          shipbar.style.width = '100%';
        }
      }
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        cards.forEach(function (x) { x.classList.remove('on'); });
        c.classList.add('on');
        render();
      });
    });
    function setQty(n) { qty = Math.max(1, Math.min(qmax, n)); render(); }
    if (qplus) qplus.addEventListener('click', function () { setQty(qty + 1); });
    if (qminus) qminus.addEventListener('click', function () { setQty(qty - 1); });
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-mode');
        modeBtns.forEach(function (x) { x.classList.toggle('on', x === b); });
        if (cadWrap) cadWrap.classList.toggle('show', mode === 'sub');
        if (saveHint) saveHint.style.display = (mode === 'sub') ? 'block' : 'none';
        render();
      });
    });
    cadBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        planId = b.getAttribute('data-plan');
        cadBtns.forEach(function (x) { x.classList.toggle('on', x === b); });
        render();
      });
    });
    // seed atc sub/otp sublabels from data attributes if present
    render();
  }
  function boot() {
    document.querySelectorAll('[data-duck-buybox]').forEach(initBox);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fet-duck-faq"] && !Shopify.designMode) return;
  try {
    
// Shopify merges every instance of this section type's javascript into one
// bundle that runs once, so we delegate from document and match the FAQ buttons
// by data attribute — this covers all FET Duck FAQ sections on the page.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-faq-toggle]');
  if (!btn) return;
  var item = btn.parentElement;
  if (item && item.classList.contains('q-item')) {
    item.classList.toggle('open');
  }
});

  } catch(e) { console.error(e); }
})();
})();
